import { Component } from '@angular/core';
import { MatModalBaseComponent } from '../../mat-modal-base.component';

@Component({
  selector: 'app-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss'],
})
export class PrivacyPolicyModalComponent extends MatModalBaseComponent<void> {}
